export default "__VITE_ASSET__XgfsZm$I__"